import { storeToRefs } from "pinia";
import { useSelectedCustomerStore } from "@/shared/stores/SelectedCustomerStore";
import type { AppIdentifier } from "@/shared/@types/AppIdentifier";
import type { RoleActions } from "@/shared/@types/RoleActions";
import { checkPermissionsByAppIdentifier } from "@/shared/helper/checkPermissionsByAppIdentifier.helper";
import { checkPermissionsByRoleAction } from "@/shared/helper/checkPermissionsByRoleAction.helper";

export const usePermission = () => {
  const selectedCustomerStore = useSelectedCustomerStore();
  const { customerRoles } = storeToRefs(selectedCustomerStore);

  return {
    hasPermission: (action: RoleActions) =>
      checkPermissionsByRoleAction(action, customerRoles.value),
    hasPermissionForApp: (appIdentifier: AppIdentifier) =>
      checkPermissionsByAppIdentifier(appIdentifier, customerRoles.value),
  };
};
